import { VStack, Box } from '@wegroup/design-system';
import React from 'react';
import useCurrentGroups from '../../hooks/useCurrentGroups';
import CompanyScanApiStatus from '../bottom-bar/CompanyScanApiStatus';
import CompanyScanProgressHeader from './CompanyScanProgressHeader';
import CompanyScanProgressItem from './CompanyScanProgressItem';
import CompanyScanToolbarWrapper from './CompanyScanToolbarWrapper';

const CompanyScanProgressToolbar: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const currentGroups = useCurrentGroups();

  return (
    <CompanyScanToolbarWrapper>
      <VStack align="stretch" justify="space-between" flexGrow={1} spacing="6">
        <Box>
          <CompanyScanProgressHeader />
          <VStack spacing="4" align="stretch">
            {currentGroups.map((group) => (
              <CompanyScanProgressItem key={group.id} group={group} />
            ))}
          </VStack>
        </Box>
        <CompanyScanApiStatus />
      </VStack>
    </CompanyScanToolbarWrapper>
  );
};

export default CompanyScanProgressToolbar;
